var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminAddDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9296 1.52113H5.07042C3.1102 1.52113 1.52113 3.1102 1.52113 5.07042V12.9296C1.52113 14.8898 3.1102 16.4789 5.07042 16.4789H15.4648C16.0249 16.4789 16.4789 16.0249 16.4789 15.4648V5.07042C16.4789 3.1102 14.8898 1.52113 12.9296 1.52113ZM5.07042 0C2.27011 0 0 2.2701 0 5.07042V12.9296C0 15.7299 2.27011 18 5.07042 18H15.4648C16.865 18 18 16.8649 18 15.4648V5.07042C18 2.27011 15.7299 0 12.9296 0H5.07042Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1155 9.65191H9.4723V13.3642C9.4723 13.7725 9.14441 14.1066 8.74366 14.1066C8.34291 14.1066 8.01502 13.7725 8.01502 13.3642V9.65191H4.37183C3.97108 9.65191 3.64319 9.31781 3.64319 8.90946C3.64319 8.50111 3.97108 8.167 4.37183 8.167H8.01502V4.45473C8.01502 4.04638 8.34291 3.71227 8.74366 3.71227C9.14441 3.71227 9.4723 4.04638 9.4723 4.45473V8.167H13.1155C13.5162 8.167 13.8441 8.50111 13.8441 8.90946C13.8441 9.31781 13.5162 9.65191 13.1155 9.65191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAddDeviceIcon);
export default __webpack_public_path__ + "static/media/AdminAddDeviceIcon.72ac74513b057aed56fb04da55d5c1d7.svg";
export { ForwardRef as ReactComponent };